import { Component, OnInit, Input, Output, EventEmitter, ViewChild, HostListener } from "@angular/core";
import { Http, Headers } from "@angular/http";
import { MedicinService } from "../services/index";
import { PrerequisiteService } from "../services/prerequisite.service";
import { CommonService } from "../services/common.service";
import { map,tap } from "rxjs/operators";
import * as $ from "jquery";
import { strictEqual } from "assert";
import { AppComponent } from "../app.component";
import { PharmacyComponent } from "../pharmacy/pharmacy.component";
import { ActivatedRoute } from '@angular/router';
import { Router, NavigationEnd } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { GoogleAnalyticsService } from "../services/google-analytics-service.service";
import { stringify } from '@angular/compiler/src/util';
import { SaveService } from '../services/save.service';
import { ApiService } from '../services/api.service';



@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
  providers: [MedicinService, PrerequisiteService, GoogleAnalyticsService]
})
export class HomeComponent implements OnInit {
  @Output() someEvent = new EventEmitter<string>();
  public DrugNameTypeSingle: boolean = false;
  public DrugFormSingle: boolean = false;
  public DrugDoseSingle: boolean = false;
  public SearchItemArray: any[] = [];
  PopularDrugs: any = [];
  BindDrugs: any = [];
  SerachList: any = [];
  SearchList: any = [];
  DrugDetailsResponseData: any = [];
  public ShowDisplay: boolean = false;
  public ShowRecentSearch: boolean = false;
  public ShowDrugdetails: boolean = false;
  private SearchText: any;
  public SelectedDrug: string = "";
  public DisplayBindList: boolean = false;
  hideme = [];
  //--------Click on drug ------------
  public Quantity_error: string = "";
  public Quantity_Manual: string = '';
  public ManualQuantity_box: boolean = false;
  public NoDrugsFound: boolean = false;
  public searchtextbox_error: string = "";
  selectedValue: string;
  optionlist: any[] = [];
  DoseDescriptor_JSON: any;
  DrugDetails: any;
  values: any;
  coordinates: any = [];
  DrugTypeList: any = [];
  DrugDoseList: any = [];
  DrugQuantityList: any = [];
  _NameFilterForQuantity: any = [];
  DrugDoseDescriptorList: any = [];
  LocationPermission: any = [];
  FormDoseData: any = [];
  ResponseData: any = [];
  PresetDrugData: any = [];
  public DrugConfigList: any = [];
  DrugDoseListCount: any;
  BrandType: boolean = false;
  GenericType: boolean = false;
  IsPresetFound: boolean = false;
  public ShowBrandDetails: boolean = false;
  public ShowGenericDetails: boolean = false;
  public DoseFormSingle: any = false;
  public StrengthSingle: any = false;
  public ShowDetails: boolean = false;
  public DrugName: string = "";
  public DrugCat: string = "";
  public DrugDose: string = "";
  public DrugQuant: any;
  public DrugType: string = "";
  public _IsBack: string = "No";
  public unregisterBackButtonAction: any;
  public Latitude: string = "";
  public Longitude: string = "";
  public Swap_Drug_With_MultiSource: string = "";
  public _UserZip = "";
  public _CurrLocation: string = "";
  public ZipCodeMessage: string = "";
  public IsAutoLocation: string = "N/A";
  //-----------Account Details-------
  public Group_Number_Box: boolean = false;
  public _AppName: string = "";
  public _AppEmail: string = "";
  public Enter_Zip: boolean = false;

  public acceptLogoArray;


  branchCopy: any;
  brandName;
  secondBrandName;
  sendno: any = "";
  sendmessageClass: any = "";
  sendmessageStatus: any = "";

  slides = [
    {
      img: "../assets/images/thumbnail_icon1.png",
      heading: "Malinda Jean , Paris",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In at mi sed velit dapibus posuere quis vitae erat."
    },
    {
      img: "../assets/images/thumbnail_icon2.png",
      heading: "Malinda Jean , Paris",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In at mi sed velit dapibus posuere quis vitae erat."
    },
    {
      img: "../assets/images/thumbnail_icon3.png",
      heading: "Malinda Jean , Paris",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In at mi sed velit dapibus posuere quis vitae erat."
    },
    {
      img: "../assets/images/thumbnail_icon1.png",
      heading: "Malinda Jean , Paris",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In at mi sed velit dapibus posuere quis vitae erat."
    },
    {
      img: "../assets/images/thumbnail_icon2.png",
      heading: "Malinda Jean , Paris",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In at mi sed velit dapibus posuere quis vitae erat."
    },
    {
      img: "../assets/images/thumbnail_icon3.png",
      heading: "Malinda Jean , Paris",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In at mi sed velit dapibus posuere quis vitae erat."
    },
    {
      img: "../assets/images/thumbnail_icon1.png",
      heading: "Malinda Jean , Paris",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In at mi sed velit dapibus posuere quis vitae erat."
    },
    {
      img: "../assets/images/thumbnail_icon2.png",
      heading: "Malinda Jean , Paris",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In at mi sed velit dapibus posuere quis vitae erat."
    },
    {
      img: "../assets/images/thumbnail_icon3.png",
      heading: "Malinda Jean , Paris",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In at mi sed velit dapibus posuere quis vitae erat."
    },
    {
      img: "../assets/images/thumbnail_icon1.png",
      heading: "Malinda Jean , Paris",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In at mi sed velit dapibus posuere quis vitae erat."
    },
    {
      img: "../assets/images/thumbnail_icon2.png",
      heading: "Malinda Jean , Paris",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In at mi sed velit dapibus posuere quis vitae erat."
    },
    {
      img: "../assets/images/thumbnail_icon3.png",
      heading: "Malinda Jean , Paris",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In at mi sed velit dapibus posuere quis vitae erat."
    }
  ];
  slideConfig = {
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: "<div class='nav-btn next-slide'></div>",
    prevArrow: "<div class='nav-btn prev-slide'></div>",
    dots: false,
    infinite: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };
  constructor(
    public http: Http,
    private ms: MedicinService,
    public rs: PrerequisiteService,
    private route: ActivatedRoute,
    public router: Router,
    private sidebarService: CommonService,
    private googleAnalyticsService: GoogleAnalyticsService,
    public SaveService:SaveService,
    public ApiService:ApiService
  ) {
    this.router.events.subscribe((ev:any) => {
      if (ev instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
    this._AppName = window.localStorage.getItem('lahrx_WhiteName');
    this._AppEmail = window.localStorage.getItem('lahrx_WhiteEmail');
    this.AppInitialize();
    this._CurrLocation = window.localStorage.getItem("lahrx_UserCurrentAddress");
    this._UserZip = window.localStorage.getItem("lahrx_userZipCode");
    this.sidebarService.apptohome.subscribe(value => {
      this.ShowDisplay = false;
      this.DisplayBindList = false;
    });
  }
  ngOnInit() {
    this.brandName = this.SaveService.getBrandName();
    this.secondBrandName = this.SaveService.getSecondBrandName();
    this.acceptLogoArray = this.SaveService.getAcceptSectionLogos();
    //------------Check status to open signup popup start here------------
    let Account_assets = this.route.snapshot.queryParamMap.get('account');
    if (this.ms.IsNullOrEmptyField(Account_assets) == false) {
      if (Account_assets.toLowerCase() == "signup") {
        if (this.rs.GetUserLoggedInStatus() == "signupscreen") {
          this.ShowDisplay = false;
          this.ShowDrugdetails = false;
          $(".signupbtnn")[0].click();
          return false;
        } else if (this.rs.GetUserLoggedInStatus() == "groupscreen") {
          this.ShowDisplay = false;
          this.ShowDrugdetails = false;
          this.Group_Number_Box = true;
          $(".TestGroup a")[0].click();
          return false;
        }
      }
    }
    //------------Check status to open signup popup end here------------

    this.getPosition1().subscribe((pos: Position) => {
      this.coordinates = {
        latitude: +pos.coords.latitude,
        longitude: +pos.coords.longitude
      };
      window.localStorage.setItem('lahrx_LocalLat', this.coordinates.latitude);
      window.localStorage.setItem('lahrx_LocalLang', this.coordinates.longitude);
    });
    $(window).on("click", () => {
      this.ShowDisplay = false;
      this.DisplayBindList = false;
      $(".menu_main").removeClass("st-effect-10");
      this.hideme = [];
    });
    // ie fix
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    var edge = ua.indexOf('Edge/');
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
    {
      $('.headermenu').css({ 'padding-top': '11px' });
    }
    if (edge > 0) {
    }
  }
  removemsgerr(e) {
    this.sendmessageStatus = "";
    this.sendmessageClass = "";
    e = e || window.event;
    var charCode = typeof e.which == "number" ? e.which : e.keyCode;
    if (!charCode || charCode == 8 /* Backspace */) {
      return;
    }

    var typedChar = String.fromCharCode(charCode);

    // Allow numeric characters
    if (/\d/.test(typedChar)) {
      return;
    }

    // Allow the minus sign (+) if the user enters it first
    if (typedChar == "+" && e.target.value.charAt() == "") {
      return;
    }
    return false;
  }
  
  // ie fix issue
  setHeight(val) {
    var outHeight = $('body').outerHeight();
    var hHome = $('.homepage').outerHeight();
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    var edge = ua.indexOf('Edge/');
    if (val == 'focusin') {
      if (hHome <= 749) {
        //$(".homepage").css({'height':`${outHeight}px`});
      }
    } else {
      $(".homepage, html, body").removeAttr('style');
    }
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./) || edge > 0)  // If Internet Explorer, return version number
    {
      $("html").css({ 'overflow-y': 'hidden' });
      if (val == 'focusin') {
        var outHeight = $('body').outerHeight();
        var hHome = $('.homepage').outerHeight();
        if (hHome <= 749) {
          $(".homepage").css({ 'height': `${outHeight}px`, 'overflow-y': 'hidden' });
          setTimeout(() => {
            $('.serachlist').css({ 'max-height': '205px', 'min-height': '205px' });
          }, 500);
        }
      } else if (val == 'focusout') {
        $("html").css({ 'overflow-y': 'hidden' });
      }
      else {
        $(".homepage, html, body, .serachlist").removeAttr('style');
      }
    }
  }
  sendmsg(val) {
    console.log(val);
    // debugger;
    if (val != "" && val.length >= 7) {
      this.ApiService
        .sendSms(val)
        .pipe(
          tap(
            data => {
              // debugger;
            },
            error => {
              // debugger;
              let errorData = (this.sendmessageStatus = JSON.parse(
                error._body
              ));
              if (errorData.code == "21408") {
                this.sendmessageStatus = "Please enter country code!";
                this.sendmessageClass = "msgerror";
              } else if (errorData.code == "21211") {
                this.sendmessageStatus = "Invalid Number";
                this.sendmessageClass = "msgerror";
              } else {
                this.sendmessageStatus = "Try a different number";
                this.sendmessageClass = "msgerror";
              }
            }
          )
        )
        .subscribe(data => {
          this.sendmessageClass = "Success_sent";
          this.sendmessageStatus = "Message Sent";
          setTimeout(() => {
            this.sendmessageClass = "";
            this.sendmessageStatus = "";
            this.sendno = "";
          }, 6000);
        });
    } else {
      this.sendmessageStatus = "Please enter a valid phone number";
      this.sendmessageClass = "msgerror";
    }

    /*
    var phoneNumber = val // +919812345678, +442071234567
    var linkData = {
      campaign: 'Microsite form Data'
    };
    var linkOptions = {
      make_new_link: false // don't create a new deep link if one already exists (e.g. _branch_match_id is in the address bar)
    };
    (function(b,r,a,n,c,h,_,s,d,k){if(!b[n]||!b[n]._q){for(;s<_.length;)c(h,_[s++]);d=r.createElement(a);d.async=1;d.src="https://cdn.branch.io/branch-latest.min.js";k=r.getElementsByTagName(a)[0];k.parentNode.insertBefore(d,k);b[n]=h}})
    (window,document,"script","branch",function(b,r){b[r]=function(){b._q.push([r,arguments])}},{_q:[],_v:1},"addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking".split(" "), 0);              
      // init Branch
      this.branch.init('key_test_kbVA7KLYjQr3IhziIq9prflaBwjkef5p');
      // document.getElementById("myBtn").addEventListener("click", function(){
      this.branch.sendSMS(val, linkData, linkOptions, function(err, data) {
      console.log(err);
    });
    */
  }
  get isSidebarVisible(): boolean {
    return this.sidebarService.isSidebarVisible;
  }
  
  clearHeight() {
    setTimeout(() => {
      $('.searchbox_home_parent').css({ 'margin-top': '0', 'transition': 'all 0.2s ease' });
    }, 600)
  }

  public getPosition1(): Observable<Position> {
    return Observable.create(observer => {
      navigator.geolocation.watchPosition((pos: Position) => {
        observer.next(pos);
      }),
        () => {
          console.log("Position is not available");
        },
        {
          enableHighAccuracy: true
        };
    });
  }

  getLock() { }

  removileview() {
    $(".searchbox_home").removeClass("mobile_searchbox_home");
  }
  AppInitialize() {
    try {
      if (this.ms.IsNullOrEmptyField(window.localStorage.getItem('lahrx_WhiteName')) == true || this.ms.IsNullOrEmptyField(window.localStorage.getItem('lahrx_WhiteEmail')) == true)
        this.ms
          .GetWhiteParams()
          .pipe(map(res => res.json()))
          .subscribe(
            data => {
              if (data.length > 0) {
                window.localStorage.setItem('lahrx_WhiteName', data[0].WhiteName);
                window.localStorage.setItem('lahrx_WhiteEmail', data[0].WhiteEmail);
                this._AppName = data[0].WhiteName;
                this._AppEmail = data[0].WhiteEmail;
              }
            },
            error => {
            }
          );
    } catch {
    }
  }
  
}
